module.exports = __webpack_public_path__ + "static/media/arles_amphi.6d959fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/arles_amphi.png
// module id = 703
// module chunks = 0